const PARENT_ONLY_COLUMNS = new Set([
  'available',
  'remainingCoursesCount',
  'allCoursesCount',
  'loopCount',
  'distanceCovered',
  'distanceToDestination',
  'vehicleType',
  'trailerId',
  'actions'
])

const COURSE_COLUMNS = new Set(['timeToDestination', 'containerTypeVolume', 'courseType', 'clientName', 'addressDisplayName'])

export const getDriverDirection = (timeToClient, timeToDepartment) => {
  if (timeToClient != null) {
    return 'Klient'
  }
  if (timeToDepartment != null) {
    return 'Baza'
  }
  return '-'
}

export const getDriverTimeToDestination = (timeToClient, timeToDepartment) => timeToClient ?? timeToDepartment ?? undefined

export const getDriverDistanceToDestination = (
  distanceToClient,
  distanceToDepartment,
  timeToClient,
  timeToDepartment
) => {
  if (timeToClient != null) {
    return distanceToClient ?? undefined
  }
  if (timeToDepartment != null) {
    return distanceToDepartment ?? undefined
  }
  return undefined
}

const mapCourseFields = (course, driver) => ({
  direction: getDriverDirection(course?.timeToClient, driver.timeToDepartment),
  timeToDestination: getDriverTimeToDestination(course?.timeToClient, driver.timeToDepartment),
  containerTypeVolume: course?.containerTypeVolume,
  courseType: course?.courseType || '-',
  clientName: course?.clientName || '-',
  addressDisplayName: course?.addressDisplayName || '-'
})

const mapDriverBaseFields = (driver, index) => ({
  ...driver,
  rowKey: `${driver.id ?? 'driver'}-${index}`,
  name: `${driver.firstName} ${driver.lastName}`,
  remainingCoursesCount: driver.remainingCoursesCount ?? '-',
  allCoursesCount: driver.allCoursesCount ?? '-',
  loopCount: driver.loopCount ?? '-',
  distanceCovered: driver.distanceCovered ?? undefined,
  distanceToDestination: getDriverDistanceToDestination(
    driver.distanceToClient,
    driver.distanceToDepartment,
    driver.timeToClient,
    driver.timeToDepartment
  )
})

export const parseDriverOccupancyRow = (driver, index) => {
  const base = mapDriverBaseFields(driver, index)
  const courses = driver.courses || []

  if (courses.length <= 1) {
    const course = courses[0]

    return {
      ...base,
      ...mapCourseFields(course, driver),
      isExpandable: false
    }
  }

  return {
    ...base,
    direction: undefined,
    timeToDestination: undefined,
    containerTypeVolume: undefined,
    courseType: undefined,
    clientName: undefined,
    addressDisplayName: undefined,
    isExpandable: true,
    groupedCourses: courses.map((course, courseIndex) => ({
      ...base,
      ...mapCourseFields(course, driver),
      rowKey: `${driver.id}-course-${course.courseId ?? courseIndex}`,
      isChildRow: true
    }))
  }
}

export const shouldShowOccupancyCell = (columnValue, item) => {
  if (columnValue === 'expand') {
    return item.isExpandable
  }

  if (item.isChildRow) {
    return !PARENT_ONLY_COLUMNS.has(columnValue)
  }

  if (item.isExpandable && COURSE_COLUMNS.has(columnValue)) {
    return false
  }

  return true
}

export const getOccupancyCellValue = (columnValue, item) => {
  if (!shouldShowOccupancyCell(columnValue, item)) {
    return ''
  }

  if (columnValue === 'direction') {
    return item.direction || '-'
  }

  return item[columnValue]
}
